import { createTheme } from "@mantine/core";

export const theme = createTheme({
  /* Default theme settings */
  primaryColor: 'indigo',
  fontFamily: 'Roboto, sans-serif',
  defaultRadius: 'sm',
});